import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Helmet } from "react-helmet-async";
import Navbar from "./Navbar";
import LoginOptions from "./LoginOptions";
import ContactSection from "./ContactSection";
import AppFooter from "./AppFooter";
import PartnerPortalPopover from "./PartnerPortalPopover";
import "../styles/oneCCDP.css";
import { useLocation, useNavigate } from 'react-router';

const LoginRedirect: React.FC = () => {
  const { login, loading: authLoading, isAuthenticated } = useAuth();
  const [selectedDistrict, setSelectedDistrict] = useState({
    id: "",
    value: "",
  });
  const location = useLocation();
  const isRefresh = location.pathname === '/refresh';
  const navigate = useNavigate();
  const hasRunRefresh = React.useRef(false);

  useEffect(() => {
    if (!isRefresh && isAuthenticated && !authLoading) {
      navigate('/dashboard', { replace: true });
    }

    const performRefresh = async () => {
      if (!hasRunRefresh.current && isRefresh && isAuthenticated && !authLoading) {
        console.log("Performing refresh");
        hasRunRefresh.current = true;
        const backendUrl =
          process.env.REACT_APP_SAML_GATEWAY_URL || "http://localhost:9000";
        console.log("Backend URL", backendUrl);
        try {
          console.log("Refreshing strategies");
          await fetch(`${backendUrl}/refresh`);
          console.log("Strategies refreshed");
        } catch (error) {
          console.error("Refresh failed:", error);
        } finally {
          navigate('/dashboard', { replace: true });
        }
      }
    };
    performRefresh();
  }, [isRefresh, isAuthenticated, navigate, authLoading, hasRunRefresh]);

  const handleDistrictChange = (v: { id: string; value: string }) =>
    setSelectedDistrict(v);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedDistrict) login(selectedDistrict.id);
  };

  return (
    <>
      <Helmet>
        <title>Sign in to Common Cloud Data Platform</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="page login-page">
        <Navbar />

        <main className="main">
          <div className="login-wrapper">
            <h1 className="login-page-title">Welcome To The Common Cloud Data Platform</h1>

            <section className="hero-card">

              <h2 className="login-card-title">
                Sign in to Common Cloud Data Platform
              </h2>

              <form onSubmit={handleSubmit}>
                <div className="field-group">
                  <LoginOptions
                    selectedDistrict={selectedDistrict.id}
                    handleDistrictChange={handleDistrictChange}
                  />

                  <p className="district-helper">
                    Your district is the California Community College district
                    where you are currently employed or authorized to access
                    system data. Once you select your district from the dropdown
                    list, you will begin the secure sign-in process. You will
                    need to use your district credentials and complete any
                    required multi-factor authentication (MFA) to access the
                    dashboard.
                  </p>
                </div>

                <button
                  className="btn-primary"
                  type="submit"
                  disabled={!selectedDistrict}
                >
                  <span>
                    {selectedDistrict.value !== ""
                      ? `Sign in with ${selectedDistrict.value}`
                      : "Please select a district"}
                  </span>
                </button>
              </form>

              {/* The trigger button linking to the popover's ID */}
              <button
                type="button"
                className="partner-portal-trigger"
                popoverTarget="partner-popover"
                popoverTargetAction="toggle"
              >
                Need the Partner Portal? Sign-in here.
              </button>

              {/* The popover element itself */}
              <div id="partner-popover" popover="auto">
                <PartnerPortalPopover />
              </div>
            </section>

            <ContactSection />

          </div>
        </main>
        <AppFooter />
      </div>
    </>
  );
};

export default LoginRedirect;
